import {
  mapTo,
  switchMap,
  mergeMap,
  map,
  filter,
  catchError,
  withLatestFrom,
  take,
  pluck,
} from 'rxjs/operators'
import { getJSON } from '../utils/fetchUtils'
import { of, from } from 'rxjs'
import { ofType } from 'redux-observable'
import Actions from '../actions'
import { getPayload } from '../utils/rxUtils'
import {
  isMinorChild,
  canJoinAppointment,
  memberIstMe,
} from '../utils/familyUtils'
import { merge } from 'ramda'
import {
  filterAppointmentsInQueue,
  filterPendingAppointments,
  filterReferrerAndPendingAppointments,
} from '../utils/appointmentsUtils'

/* add myself to the call if this is my minor child */
export const addParticipantsToAppointment = (actions$, state$) =>
  actions$.pipe(
    getPayload(Actions.CHOOSE_FAMILY_MEMBER),
    withLatestFrom(state$),
    filter(([{ member }, state]) => member && !memberIstMe(member, state)),
    filter(([{ member }, _]) => canJoinAppointment(member)),
    map(([_, state]) =>
      Actions.createAction(Actions.CHOOSE_OTHER_MEMBER, {
        member: state.profile?.userDetails,
      })
    )
  )

export const appointmentApprovalEpic = action$ =>
  action$.pipe(
    getPayload(Actions.APP_LAUNCHED),
    switchMap(() =>
      action$.pipe(
        getPayload(Actions.APPOINTMENTS_POLL_RECEIVED),
        take(1),
        mergeMap(payload => {
          return of(
            Actions.createAction(Actions.APPOINTMENT_APPROVAL_ENDED, payload),
            Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
              eventName: Actions.APPOINTMENT_APPROVAL_ENDED + '_WEB',
            })
          )
        })
      )
    )
  )

export const changeAppointmentReloadProfile = actions$ =>
  actions$.pipe(
    getPayload(
      Actions.CANCEL_APPOINTMENT_RECEIVED,
      Actions.RESCHEDULE_APPOINTMENT_RECEIVED
    ),
    mapTo(Actions.createAction(Actions.USER_PROFILE_REQUESTED))
  )

export const afterCancelAppointment = actions$ =>
  actions$.pipe(
    getPayload(Actions.CANCEL_APPOINTMENT_RECEIVED),
    mergeMap(() => of(Actions.createAction(Actions.SLOT_CLEARED)))
  )

export const afterRescheduleAppointment = actions$ =>
  actions$.pipe(
    getPayload(Actions.RESCHEDULE_APPOINTMENT_RECEIVED),
    withLatestFrom(actions$.pipe(getPayload(Actions.USER_PROFILE_RECEIVED))),
    mapTo(Actions.createAction(Actions.SHOW_RESCHEDULE_APPOINTMENT))
  )

export const slotSavedTimerStart = action$ =>
  action$.pipe(
    getPayload(
      Actions.APPOINTMENT_APPROVAL_ENDED,
      Actions.APPOINTMENTS_POLL_RECEIVED
    ),
    switchMap(({ appointments }) =>
      filterReferrerAndPendingAppointments(appointments)
    ),
    filter(pending => pending),
    map(({ expire_time }) => {
      return Actions.createAction(Actions.ACTIVATE_SLOT_TIMER, {
        expireTime: expire_time,
      })
    })
  )

const shouldShowEtaTimer = appointments => {
  const pending = filterReferrerAndPendingAppointments(appointments)
  const inQueue = filterAppointmentsInQueue(appointments)
  // show timer when there is no pending and inqueue only appointments
  return !pending?.length && inQueue?.length
}

export const etaTimerStartWithExistEta = (action$, state$) =>
  action$.pipe(
    getPayload(
      Actions.APPOINTMENT_APPROVAL_ENDED,
      Actions.APPOINTMENTS_POLL_RECEIVED
    ),
    withLatestFrom(state$),
    filter(([{ appointments }, _]) => shouldShowEtaTimer(appointments)),
    map(([_, state]) => {
      const eta = state.appointments?.eta
      return Actions.createAction(Actions.ACTIVATE_SLOT_TIMER, {
        eta,
      })
    })
  )

export const createAppointment = (actions$, state$) =>
  actions$.pipe(
    getPayload(Actions.PAYMENT_FLOW_COMPLETED),
    withLatestFrom(state$),
    switchMap(([_, { appointments }]) => {
      const { selectedTimeOption } = appointments
      return of(
        Actions.createAction(Actions.CREATE_APPOINTMENT_REQUESTED, {
          timeWindow: selectedTimeOption,
          designatedPk: appointments?.designatedPk,
        })
      )
    })
  )

export const appointmentNotApprovedYetMessage = action$ => {
  return action$.pipe(
    getPayload(Actions.APPOINTMENT_APPROVAL_ENDED),
    pluck('appointments'),
    switchMap(filterPendingAppointments),
    filter(pendingAppointment => !pendingAppointment?.length),
    map(pendingAppointment =>
      Actions.createAction(
        Actions.PENDING_APPOINTMENT_FOUND,
        pendingAppointment
      )
    )
  )
}
